import { 
    SiAndroid, SiC, SiCss3, SiExpress,
    SiGit, SiGithub, SiHtml5, SiJava, SiJavascript,
    SiNodedotjs, SiPostgresql, SiPostman, SiReact,
    SiRedux, SiSequelize, SiSpringboot, SiSqlite,
    SiTypescript 
} from "react-icons/si";
import { SiJirasoftware } from "react-icons/si";
import { GrMysql } from "react-icons/gr";
import { DiScrum } from "react-icons/di";

import "../css/Skill.css";

export default function Skill() {

    const techs = {
        frontend: [
            {
                name: "HTML",
                color: "#efd81d",
                component: <SiHtml5 className="icon-skill" />
            },
            {
                name: "CSS",
                color: "#efd81d",
                component: <SiCss3 className="icon-skill" />
            },
            {
                name: "JavaScript",
                color: "#efd81d",
                component: <SiJavascript className="icon-skill" />
            },
            {
                name: "React",
                color: "#efd81d",
                component: <SiReact className="icon-skill" />
            },
            {
                name: "Redux",
                color: "#efd81d",
                component: <SiRedux className="icon-skill" />
            },
        ],
        backend: [
            {
                name: "Java",
                color: "#efd81d",
                component: <SiJava className="icon-skill" />
            },
            {
                name: "Spring Boot",
                color: "#efd81d",
                component: <SiSpringboot className="icon-skill" />
            },
            {
                name: "MySQL",
                color: "#efd81d",
                component: <GrMysql className="icon-skill" />
            },
            {
                name: "Node",
                color: "#efd81d",
                component: <SiNodedotjs className="icon-skill" />
            },
            {
                name: "Express",
                color: "#efd81d",
                component: <SiExpress className="icon-skill" />
            },
            {
                name: "PostgreSQL",
                color: "#efd81d",
                component: <SiPostgresql className="icon-skill" />
            },
            {
                name: "Sequelize",
                color: "#efd81d",
                component: <SiSequelize className="icon-skill" />
            },
            {
                name: "SQLite",
                color: "#efd81d",
                component: <SiSqlite className="icon-skill" />
            },
        ],
        tools: [
            {
                name: "Git",
                color: "#efd81d",
                component: <SiGit className="icon-skill" />
            },
            {
                name: "GitHub",
                color: "#efd81d",
                component: <SiGithub className="icon-skill" />
            },
            {
                name: "Postman",
                color: "#efd81d",
                component: <SiPostman className="icon-skill" />
            },
            {
                name: "Jira",
                color: "#efd81d",
                component: <SiJirasoftware className="icon-skill" />
            }
        ],
        others: [
            {
                name: "SCRUM",
                color: "#efd81d",
                component: <DiScrum className="icon-skill icon-skill-big" />
            },
            {
                name: "Android",
                color: "#efd81d",
                component: <SiAndroid className="icon-skill icon-skill-big" />
            },
            {
                name: "TypeScript",
                color: "#efd81d",
                component: <SiTypescript className="icon-skill" />
            },
            {
                name: "C",
                color: "#efd81d",
                component: <SiC className="icon-skill" />
            },
        ]
    }

    return (
        <div className="skill fadeIn">
            <div className="content-tech-skill">
                <h1 className="title-main-skill">HABILIDADES</h1>
                <p className="title-tech-skill">BACKEND</p>
                <div className="card-tech-skill">
                    {techs.backend.map((tech, i) =>
                        <span key={i} className="span-skill">
                            {tech.component}
                            {tech.name}
                        </span>
                    )}
                </div>
                <p className="title-tech-skill">FRONTEND</p>
                <div className="card-tech-skill">
                    {techs.frontend.map((tech, i) =>
                        <span key={i} className="span-skill">
                            {tech.component}
                            {tech.name}
                        </span>
                    )}
                </div>
                <p className="title-tech-skill">HERRAMIENTAS</p>
                <div className="card-tech-skill">
                    {techs.tools.map((tech, i) =>
                        <span key={i} className="span-skill">
                            {tech.component}
                            {tech.name}
                        </span>
                    )}
                </div>
                <p className="title-tech-skill">OTROS</p>
                <div className="card-tech-skill">
                    {techs.others.map((tech, i) =>
                        <span key={i} className="span-skill">
                            {tech.component}
                            {tech.name}
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
}